export const DEFAULT_DEMOGRAPHIC_TARGET = {
  genderTargetConfigType: 'ALL',
  genders: [],
  ageTargetConfigType: 'ALL',
  ageGroups: []
};

export const GENDER_OPTIONS = [
  {label: '남성', value: 'MALE'},
  {label: '여성', value: 'FEMALE'},
  {label: '미상', value: 'UNKNOWN'}
];

export const AGE_GROUP_OPTIONS = [
  {label: '10대', value: 'AGE_10_19'},
  {label: '20대', value: 'AGE_20_29'},
  {label: '30대', value: 'AGE_30_39'},
  {label: '40대', value: 'AGE_40_49'},
  {label: '50대', value: 'AGE_50_59'},
  {label: '60대 이상', value: 'AGE_60_PLUS'},
  {label: '미상', value: 'UNKNOWN'}
];